import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { GripVertical, Pencil, Trash2 } from 'lucide-react'
import type { Campo } from '../types'
import { TIPO_CAMPO_LABELS } from '../types'

interface CampoCardProps {
  campo: Campo
  onEdit: (campo: Campo) => void
  onDelete: (campo: Campo) => void
  canEdit: boolean
}

export function CampoCard({ campo, onEdit, onDelete, canEdit }: CampoCardProps) {
  return (
    <div className="flex items-center gap-3 p-3 border rounded-lg border-gray-300 dark:border-gray-700 hover:shadow-sm transition-shadow">
      {canEdit && (
        <GripVertical className="h-5 w-5 text-muted-foreground cursor-grab flex-shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-muted-foreground w-6">{campo.orden}</span>
          <Badge variant="outline" className="text-xs">{TIPO_CAMPO_LABELS[campo.tipo] || campo.tipo}</Badge>
          <span className="font-medium truncate">{campo.etiqueta}</span>
          {campo.requerido && <Badge variant="destructive" className="text-xs">Requerido</Badge>}
        </div>
        {campo.descripcion && (
          <p className="text-xs text-muted-foreground mt-1 ml-8 truncate">{campo.descripcion}</p>
        )}
      </div>
      {canEdit && (
        <div className="flex items-center gap-1 flex-shrink-0">
          <Button variant="ghost" size="sm" onClick={() => onEdit(campo)}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={() => onDelete(campo)}>
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      )}
    </div>
  )
}
